import axios from "axios";
import {
    isLocal, isUKDevelopment, isUKProduction, isUSDevelopment, isUSProduction,
} from "./serviceConfig";
import { isVersionUK, isVersionUS } from "./versionService";

export const DEV_UK_REG_API_DOMAIN = "https://register-test.kingsinterhigh.co.uk";
export const PROD_UK_REG_API_DOMAIN = "https://register.kingsinterhigh.co.uk";

export const DEV_US_REG_API_DOMAIN = "https://application-test.gouspa.org";
export const PROD_US_REG_API_DOMAIN = "https://application.gouspa.org";

export const getRegApiDomain = () => {
    if ((isLocal && isVersionUK)) return DEV_UK_REG_API_DOMAIN;
    if ((isLocal && isVersionUS)) return DEV_US_REG_API_DOMAIN;

    if (isUKDevelopment) return DEV_UK_REG_API_DOMAIN;
    if (isUSDevelopment) return DEV_US_REG_API_DOMAIN;
    if (isUKProduction) return PROD_UK_REG_API_DOMAIN;
    if (isUSProduction) return PROD_US_REG_API_DOMAIN;

    return "";
};

const apiDomain = getRegApiDomain();
const defaultConfig = {
    headers: { "Content-type": "application/json" },
};

const axiosManagerRegister = {
    axiosInstance: axios.create({
        baseURL: apiDomain,
        headers: {
            "Access-Control-Allow-Origin": "*",
            ...defaultConfig.headers,
        },
    }),

    sessionKey: null,
    requestInterceptorId: null,

    setSessionKey(sessionKey) {
        if (this.requestInterceptorId !== null) {
            this.axiosInstance.interceptors.request.eject(this.requestInterceptorId);
        }

        this.sessionKey = sessionKey;

        this.requestInterceptorId = this.axiosInstance.interceptors.request.use(
            (config) => {
                if (config.headers && this.sessionKey) {
                    // eslint-disable-next-line no-param-reassign
                    config.headers["X-Session-Key"] = this.sessionKey;
                }

                return config;
            },
            (error) => Promise.reject(error),
        );
    },

    removeSessionKey() {
        this.sessionKey = null;

        if (this.requestInterceptorId !== null) {
            this.axiosInstance.interceptors.request.eject(this.requestInterceptorId);
            this.requestInterceptorId = null;
        }
    },

    request$(url, method, data, config) {
        return new Promise((resolve, reject) => {
            const configMerged = {
                ...defaultConfig,
                ...config,
                headers: { ...defaultConfig.headers, ...(config?.headers || {}) },
            };

            this.axiosInstance.request({
                ...configMerged,
                url,
                method,
                data,
            })
                .then(resolve)
                .catch(reject);
        });
    },

    get$(url, config) {
        return this.request$(url, "get", null, config);
    },

    post$(url, args, config) {
        return this.request$(url, "post", args, config);
    },

    put$(url, args, config) {
        return this.request$(url, "put", args, config);
    },

    patch$(url, args, config) {
        return this.request$(url, "patch", args, config);
    },

    head$(url) {
        return this.request$(url, "head");
    },

    delete$(url, args) {
        return this.request$(url, "delete", args);
    },
};

export default axiosManagerRegister;
